import * as React from "react";
import styles from "./styles.scss";
import cx from "classnames";
export interface Props {
  children: React.ReactNode;
  className?: string;
  narrow?: boolean;
  fullSize?: boolean;
  short?: boolean;
  gutter?: boolean;
}

export default function PageContent({ children, className, narrow, fullSize, short, gutter }: Props) {
  const classes = cx(
    styles.pageContent,
    className,
    fullSize && styles.fullSize,
    narrow && styles.narrow,
    short && styles.short,
    gutter && styles.gutter,
  );

  return <div className={classes}>{children}</div>;
}
